(() => {
  const ROOT_ATTR = 'data-gb';
  const MOTION_ATTR = 'data-gb-motion';
  const STATIC_ATTR = 'data-gb-static';
  const DONE_ATTR = 'data-gb-done';
  const RETRY_MS = 80;
  const RETRY_MAX = 40;

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const showStatic = (root) => {
    if (root) root.setAttribute(STATIC_ATTR, '');
  };

  const destroyMotion = (root) => {
    if (!root) return;
    if (root._gbRetry) {
      window.clearTimeout(root._gbRetry);
      root._gbRetry = null;
    }
    if (root._gbCtx) {
      root._gbCtx.revert();
      root._gbCtx = null;
    }
    root.removeAttribute(MOTION_ATTR);
    root.removeAttribute(STATIC_ATTR);
    root.removeAttribute(DONE_ATTR);
  };

  const setupMotion = (root, attempt) => {
    if (!root || root.hasAttribute(MOTION_ATTR)) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if ((attempt || 0) < RETRY_MAX) {
        root._gbRetry = window.setTimeout(() => setupMotion(root, (attempt || 0) + 1), RETRY_MS);
        return;
      }
      showStatic(root);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    root.setAttribute(MOTION_ATTR, '');

    if (prefersReducedMotion()) {
      showStatic(root);
      return;
    }

    const items = root.querySelectorAll('[data-gb-item]');
    if (!items.length) return;

    root._gbCtx = gsap.context(() => {
      gsap.set(items, { autoAlpha: 0, y: 24 });
      gsap.to(items, {
        autoAlpha: 1,
        y: 0,
        duration: 0.45,
        ease: 'power2.out',
        overwrite: true,
        onComplete: () => {
          gsap.set(items, { clearProps: 'transform' });
          root.setAttribute(DONE_ATTR, '');
        },
        scrollTrigger: {
          trigger: root,
          start: 'top 75%',
          once: true
        }
      });
    }, root);
  };

  const scan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach((root) => setupMotion(root, 0));
  };

  const rescan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach(destroyMotion);
    scan();
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector(`[${ROOT_ATTR}]`);
    if (root) destroyMotion(root);
  });
})();
